import { Component, inject, OnInit, signal } from '@angular/core';
import { MessageService } from 'primeng/api';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';
import { ActivatedRoute, Router } from '@angular/router';
import { CompararResponse } from '../../models/Comparar.model';
import { OfertasService } from '../../services/OfertasService';
import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { SkeletonModule } from 'primeng/skeleton';
import { APP_ROUTES } from '../../../../core/constants/routes.const';
import { ProveedorToEnumMap } from '../../../../core/enums/comparadores.20td.enum';
import { Tooltip } from 'primeng/tooltip';
import { Checkbox } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { Dialog } from 'primeng/dialog';

@Component({
  selector: 'app-ofertas-comparar',
  standalone: true,
  imports: [
    CommonModule,
    TableModule,
    ButtonModule,
    CardModule,
    TagModule,
    SkeletonModule,
    ToastModule,
    Tooltip,
    Checkbox,
    FormsModule,
    Dialog,
  ],
  providers: [MessageService],
  templateUrl: './ofertas-comparar.component.html',
  styleUrl: './ofertas-comparar.component.scss',
})
export class OfertasCompararComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly ofertasApi = inject(OfertasService);
  private readonly messages = inject(MessageService);

  loading = signal(true);
  comparativa = signal<CompararResponse | null>(null);

  mostrarModal = false;

  ngOnInit() {
    const id = Number(this.route.snapshot.paramMap.get('id'));
    this.ofertasApi.compararOferta(id).subscribe({
      next: (data) => this.comparativa.set(data),
      error: () => {
        this.messages.add({ severity: 'error', summary: 'Error', detail: 'No se pudo obtener la comparativa' });
        this.router.navigate([`/${APP_ROUTES.OFERTAS.DETALLE(id)}`]);
      },
      complete: () => this.loading.set(false),
    });
  }

  volver() {
    const id = Number(this.route.snapshot.paramMap.get('id'));
    this.router.navigate([`/${APP_ROUTES.OFERTAS.DETALLE(id)}`]);
  }

  descargarPdf(row: any) {
    const comparadorEnum = ProveedorToEnumMap[row.proveedor];
    if (!comparadorEnum) {
      this.messages.add({
        severity: 'warn',
        summary: 'Proveedor no soportado',
        detail: `No hay comparador configurado para ${row.proveedor}`,
      });
      return;
    }

    const ofertaId = this.comparativa()!.oferta.id;

    this.ofertasApi.descargarPdf(ofertaId, comparadorEnum).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `Oferta_${ofertaId}_${row.proveedor}.pdf`;
        a.click();
        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.messages.add({
          severity: 'error',
          summary: 'Error',
          detail: `No se pudo descargar el PDF para ${row.proveedor}`,
        });
      },
    });
  }

  imprimir() {
    const tabla = document.querySelector('.comparativa-tabla') as HTMLElement;
    if (!tabla) return;

    const ventana = window.open('', '_blank', 'width=900,height=600');
    if (ventana) {
      ventana.document.write(`
      <html>
        <head>
          <title>Comparativa</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
            table { border-collapse: collapse; width: 100%; }
            th, td { border: 1px solid #ddd; padding: 8px; text-align: center; }
            th { background: #f4f4f4; }
          </style>
        </head>
        <body>
          ${tabla.outerHTML}
        </body>
      </html>
    `);
      ventana.document.close();
      ventana.print();
    }
  }

  enviarOferta(row: any) {
    this.mostrarModal = true;
  }
}
